import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { Layout } from '@singularsystems/neo-canvas-grid';
import MaintenanceIndexFragmentationReportCriteria from "./MaintenanceIndexFragmentationReportCriteria";

@NeoReport("MaintenanceIndexFragmentation", { category: MaintenanceReportCategories.SystemInformationReports })
export default class MaintenanceIndexFragmentationReport extends Report<MaintenanceIndexFragmentationReportCriteria> {

    constructor() {
        super(MaintenanceIndexFragmentationReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}